// extracted by mini-css-extract-plugin
module.exports = {"container":"ChangeNotes_container__1nqAM"};